import React from 'react';
import { Autocomplete, Box, Button, IconButton, Stack, TextField, Tooltip, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

// The filter of a rule set, edited the way an endpoint schedule's filter is: "label is value" rows, all of which a machine must match.
// `choices` are the labels the machines carry and their values ({ label: [values] }), offered while typing; anything can be typed.
function FilterEditor({ filter, onChange, choices }) {
  const names = Object.keys(choices || {});
  const valuesOf = (label) => (choices || {})[names.find((k) => k.toLowerCase() === String(label).trim().toLowerCase())] || [];
  const set = (index, patch) => onChange(filter.map((f, i) => (i === index ? { ...f, ...patch } : f)));

  return (
    <Box>
      <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>Machines whose labels match all of these</Typography>
      <Stack spacing={1.5}>
        {filter.map((f, i) => (
          <Stack key={i} direction="row" spacing={1} alignItems="center">
            <Autocomplete
              freeSolo options={names} inputValue={f.label} fullWidth size="small" onInputChange={(e, value) => set(i, { label: value })}
              renderInput={(params) => <TextField {...params} label={`Filter ${i + 1} label`} />}
            />
            <Typography variant="body2" color="text.secondary">is</Typography>
            <Autocomplete
              freeSolo options={valuesOf(f.label)} inputValue={f.value} fullWidth size="small" onInputChange={(e, value) => set(i, { value })}
              renderInput={(params) => <TextField {...params} label={`Filter ${i + 1} value`} />}
            />
            <Tooltip title="Remove this filter"><span>
              <IconButton size="small" aria-label={`Remove filter ${i + 1}`} disabled={filter.length === 1} onClick={() => onChange(filter.filter((_, j) => j !== i))}>
                <RemoveCircleOutlineIcon fontSize="small" />
              </IconButton>
            </span></Tooltip>
          </Stack>
        ))}
      </Stack>
      <Button size="small" startIcon={<AddIcon />} sx={{ mt: 1 }} disabled={filter.length >= 10} onClick={() => onChange([...filter, { label: '', value: '' }])}>Add filter</Button>
    </Box>
  );
}

export default FilterEditor;
